import { Box, Button, Divider, Heading, HStack, Stack, Tag, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import { dateTimezoneTransformer } from '../../helpers/dateTransformer';

const RecentlyCheckedCard = (props: { checkTask(): void; dateTaskCheckedByUser: string | undefined }) => {
  const { dateTaskCheckedByUser, checkTask } = props;
  const { t } = useTranslation();

  return (
    <Box bgColor="white" borderRadius={'8px'} boxShadow="md">
      {dateTaskCheckedByUser !== null ? (
        <Stack gap="0">
          <HStack p="4">
            <Heading size="xs" as="h2">
              {t('activity:checked.heading')}
            </Heading>
            <Tag colorScheme="green">{t('activity:checked.tag.checked')}</Tag>
          </HStack>
          <Divider />
          <Stack p="4">
            <Text>
              {t('activity:checked.by_user')}
              {dateTimezoneTransformer(dateTaskCheckedByUser, 'Europe/Vienna', true) + '.'}
            </Text>
          </Stack>
        </Stack>
      ) : (
        <Stack>
          <Stack gap="0">
            <HStack p="4">
              <Heading size="xs" as="h2">
                {t('activity:checked.heading')}
              </Heading>
              <Tag colorScheme="gray">{t('activity:checked.tag.not_checked')}</Tag>
            </HStack>
            <Divider width="fill" />
            <HStack p="4" justifyContent="space-between">
              <Text>{t('activity:checked.to_be_checked_by_user')} </Text>
              <Button variant={'primary'} onClick={checkTask}>
                {t('activity:checked.button')}
              </Button>
            </HStack>
          </Stack>
        </Stack>
      )}
    </Box>
  );
};

export default RecentlyCheckedCard;
